    import axiosAuth from '../../../shared/configs/axios-auth'

    const getDefaultState = () => {
        return {
            extras: [],
        }
    }
    
    const state = getDefaultState()

    const getters = {
        extras: state => {
            return state.extras
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        extras: (state, payload) => {
            state.extras = payload
        },
    }

    const actions = {
       
        getExtras: ({commit}) =>{
            commit('updating', true)
            axiosAuth.get('/extras')
            .then(
                res => {
                    commit('updating', false)
                    if(!res.data.message){
                        commit('extras', res.data)
                    }

                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)
                }
              )
        },

        postExtra ({commit, dispatch}, payload) {
            commit('updating', true)
            axiosAuth.post('/extras', payload)
                .then(
                    res => {
                        commit('trash', res)
                        commit('updating', false)
                        dispatch('getExtras')
                    }
                )
                .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
                )
        },

        updateExtra: ({commit, dispatch}, payload) => {
            console.log('payload:', payload)
            
            commit('updating', true)
            axiosAuth.patch('/extras/'+ payload._id, payload.data)
            .then(
                res => {
                    commit('trash', res)
                    commit('updating', false)
                    dispatch('getMenus')         
                }
              )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },

        deleteExtra: ({commit, dispatch}, payload) => {
            commit('updating', true)
            axiosAuth.delete('/extras/'+ payload._id)
            .then(
                () => {
                    dispatch('getExtras')
                }
              )
            .catch(
                error => {
  
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },
    }

    export default {
        state,
        getters,
        mutations,
        actions
    }